var map = {
	"./projects/Catalyst/project.js": 29963,
	"./projects/DGD-NeRF/project.js": 61557,
	"./projects/Deep3dComp/project.js": 71801,
	"./projects/EthicAI/project.js": 94231,
	"./projects/Logzilla/project.js": 32298,
	"./projects/Musio/project.js": 31907,
	"./projects/PWTerm/project.js": 74666,
	"./projects/PeakFocus/project.js": 28953,
	"./projects/Rollbody/project.js": 56348,
	"./projects/example/project.js": 59592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79138;